import { ReactElement } from 'react';
import { observer } from 'mobx-react-lite';
import { Export } from '../common/components/export/export';

export const FrExportDrawer = observer(function FRExportDrawer(): ReactElement {
    return <Export isDrawer />;
});

type FrExportDrawerType = typeof FrExportDrawer;

export type { FrExportDrawerType };
